import { render, staticRenderFns } from "./TechExamsBreakdown.vue?vue&type=template&id=68b45e36&scoped=true&"
import script from "./TechExamsBreakdown.vue?vue&type=script&lang=js&"
export * from "./TechExamsBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b45e36",
  null
  
)

export default component.exports